import { TemplateData, TemplateParams } from '.';

const pathInvite = ({
  defaultPlaceholders,
  messages,
  serverConfig
}: TemplateParams): TemplateData => ({
  category: 'paths',
  email: {
    buttonEnabled: true,
    buttonLink: '{{pathUrl}}',
    buttonText: messages.authSignIn,
    content: `
      <p>
        ${messages.pathInviteAddedToPathInfo}
        ${messages.pathInviteAddedToPathAccess}
      </p>`,
    contentAfterButton: `
      <p>
        ${messages.courseFindAllCourses}
        ${
          serverConfig.authEnableLocalLogin &&
          !serverConfig.emailHidePasswordResetInfo
            ? messages.emailResetPasswordContent
            : ''
        }
      </p>
      <p>
        ${messages.emailSignatureText}
      </p>`,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    heading: messages.emailGreeting,
    subject: `{{siteName}}: ${messages.pathInviteAddedToPath}`
  },
  placeholders: {
    pathTitle: {
      label: messages.pathsPathTitle,
      example: 'Test path'
    },
    pathUrl: {
      label: messages.pathsPathLink,
      example: `${serverConfig.adminUrl}/paths/1`
    },
    ...defaultPlaceholders
  },
  title: messages.emailTypePathInvite
});

export default pathInvite;
